import React from 'react'
import Navigation from '../components/Navigation/Navigation'
import Products from '../components/Products'

const ProductsPage = () => {
    return (
        <>
            <Navigation />
            <Products />
        </>
    )
}

export default ProductsPage
